module.exports = __webpack_public_path__ + "e6bc8f3d9e25a0dbc86876538a360091.pdf";